export default "__VITE_ASSET__DEPqAVGZ__"